<template>
  <component :is="editable ? Host : Guest"></component>
</template>

<script setup lang="ts">
import Host from './Host.vue';
import Guest from './Guest.vue';
import { usePersonalPageEditable } from './hooks';

const userInfo = useUserInfo();

provideResourceLocation({
  source: SOURCE.PERSONAL_PAGE,
});

watch(
  () => userInfo.value?.organization_id,
  v => {
    if (v) {
      location.href = `/personal-page/${v}.html`;
    }
  },
);

onMounted(() => {
  trackEvent(TRACK_EVENT.PAGE_PERSONAL_PAGE, {
    user_nickname: userInfo.value?.username,
  });
});

const editable = usePersonalPageEditable();
</script>
